import { htmlToBisonPlainText } from './htmlToBisonPlainText'

interface EmailFooterPreviewProps {
  /** Signature value from the sender email account (plain text, optionally
   *  with legacy `<p>` wrappers from older saves). */
  signature?: string
}

/**
 * Renders the email footer (signature) for preview panels exactly as
 * recipients will see it: as plain text. `htmlToBisonPlainText` is a
 * defensive pass for legacy values that still carry `<p>`/`<br>` markup.
 */
export function EmailFooterPreview({ signature }: EmailFooterPreviewProps) {
  if (!signature) return null
  const text = htmlToBisonPlainText(signature)
  if (!text) return null

  return (
    <div className="mt-3 max-w-none whitespace-pre-wrap text-sm leading-snug text-fg-secondary [overflow-wrap:anywhere]">
      {text}
    </div>
  )
}
